import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { ClassRoom } from '../classroom.js';

export const getClassRoomsByIdsQuery = registerQuery({
  operationName: 'getClassRoomsByIdsQuery',
  type: () => [ClassRoom],
  params: [{ name: 'ids', type: () => [String] }],

  resolve: (ids: string[]) => async (_gqlFields: BaseQLSelectionSet<ClassRoom>): Promise<ClassRoom[]> => {
    const normalizedIds = Array.isArray(ids) ? ids.filter(id => typeof id === 'string' && id.length > 0) : [];
    if (normalizedIds.length === 0) return [];

    const classroomCollection = await getCollection(ClassRoom);
    const classrooms = await classroomCollection.find({ _id: { $in: normalizedIds } }).toArray();

    return classrooms as ClassRoom[];
  },
});
